// extracted by mini-css-extract-plugin
export default {"LiveMessages":"LiveMessages_LiveMessages__9Efn1","Message":"LiveMessages_Message__dCoYs","MessageHead":"LiveMessages_MessageHead__NLCnY","message":"LiveMessages_message__2Tt3L"};